import React, { useContext, useEffect, useState } from "react";
import {
  EditPopover,
  FilterInput,
  NumberInput,
  Panel,
  RadioButtonInput,
  RangeNumberInput,
  SelectInput,
  Tabs,
  TabsV2,
  TextInput,
  ToggleInput,
  UnitInput,
} from "../input";
import { GrigoraEditorContext } from "../editor/context";
import { isEmpty } from "lodash";
import GrigoraCSSRenderer from "../blocks/css-render";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGear,
  faPlay,
  faRefresh,
  faStop,
} from "@fortawesome/free-solid-svg-icons";
import { GrigoraDashboardContext } from "../dashboard/context";
import { getDirectoryInfoFromParents, isUpdatedFromDefault } from "../utils";
import { INPUT_LIMITS } from "../input-limits";
import { useEditor } from "@craftjs/core";
import { remove_prefix } from "../helpers";

function DirectoryConditional({ block, actions, ...props }) {
  const {
    id,
    props: { directoryConditionalFilters = {} },
    dom,
  } = block;

  const { setProp } = actions;

  const { pagesData, currentPage } = useContext(GrigoraEditorContext) ?? {};
  const { projectID, directoryTypes } =
    useContext(GrigoraDashboardContext) ?? {};

  const {
    query: { node },
    query,
  } = useEditor();

  const parents = node(id).ancestors(true);

  const directoryContext = (() => {
    const directoryInfo = getDirectoryInfoFromParents(parents, node);

    if (directoryInfo) {
      return directoryInfo;
    }

    // Check if current page is a directory listing page
    var currentPageData = pagesData?.[currentPage] ?? {};

    if (
      currentPageData?.type === "template" &&
      currentPageData?.template === "directory-template" &&
      currentPageData?.directory_id
    ) {
      return {
        directoryTypeId: currentPageData?.directory_id,
      };
    }

    return null;
  })();

  return (
    <>
      {directoryContext?.directoryTypeId && (
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: directoryConditionalFilters, default: {} },
          ])}
          id={`block-setting-${id}-conditional`}
          title={"Directory Conditional Visibility"}
          initialOpen={true}
        >
          <FilterInput
            value={directoryConditionalFilters?.filters}
            onChange={(val) => {
              setProp((props) => {
                props.directoryConditionalFilters = {
                  ...(props.directoryConditionalFilters ?? {}),
                  filters: val,
                };
              });
            }}
            matchType={directoryConditionalFilters?.filtersMatchType}
            onMatchTypeChange={(val) => {
              setProp((props) => {
                props.directoryConditionalFilters = {
                  ...(props.directoryConditionalFilters ?? {}),
                  filtersMatchType: val,
                };
              });
            }}
            label="Filters"
            fields={
              directoryTypes?.find(
                (type) =>
                  remove_prefix(type.sk, "directory-type-") ===
                  directoryContext?.directoryTypeId,
              )?.fields
            }
          />
        </Panel>
      )}
    </>
  );
}

function transformProps(props, supportProps) {
  if (props.entranceAnimation && !isEmpty(props.entranceAnimation)) {
    supportProps = {
      ...supportProps,
      className: {
        ...(supportProps.className ? supportProps.className : {}),
        [`entrance-${props.id}`]: true,
      },
    };
  }
  return supportProps;
}

function dynamicCSS(id, props) {
  const { entranceAnimation } = props;

  if (!(props.entranceAnimation && !isEmpty(props.entranceAnimation))) {
    return ``;
  }

  return ``;
}

const supportSchema = {
  id: "grigora/directory-conditional",
  name: "Directory Conditional",
  component: DirectoryConditional,
  transformProps: transformProps,
  dynamicCSS: dynamicCSS,
};

export default supportSchema;
